import * as React from 'react';
import {i18n} from '@src/utils/i18n';
import nls from './nls';
import * as css from './style.m.css';

const I18N = i18n(nls);

export default () => {
  return (
    <div className={css.center}>
      <div className="centerContent">
        <h1>ERROR</h1>
        <div>{I18N['抱歉，你访问的页面出错了。']}</div>
      </div>
    </div>
  );
}
